import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_RELEASE } from './appRelease';
import './AppDownload.css';

const AppDownload = () => {
  const { t, i18n } = useTranslation();
  const date = new Date(`${APP_RELEASE.releasedAt}T00:00:00`);
  const dateLabel = Number.isNaN(date.getTime())
    ? APP_RELEASE.releasedAt
    : date.toLocaleDateString(i18n.language === 'ar' ? 'ar-DZ' : i18n.language === 'fr' ? 'fr-DZ' : 'en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

  return (
    <div className="app-download-page">
      <div className="app-download-hero">
        <div className="container">
          <h1>{t('appDownload.title')}</h1>
          <p>{t('appDownload.subtitle')}</p>
        </div>
      </div>
      <div className="container app-download-body">
        <div className="app-download-card">
          <h2>{APP_RELEASE.name}</h2>
          <dl>
            <div>
              <dt>{t('appDownload.version')}</dt>
              <dd>
                {APP_RELEASE.version} ({t('appDownload.versionCode')} {APP_RELEASE.versionCode})
              </dd>
            </div>
            <div>
              <dt>{t('appDownload.released')}</dt>
              <dd>{dateLabel}</dd>
            </div>
            <div>
              <dt>{t('appDownload.size')}</dt>
              <dd>{APP_RELEASE.size}</dd>
            </div>
            <div>
              <dt>SHA-256</dt>
              <dd className="app-download-hash">{APP_RELEASE.sha256}</dd>
            </div>
          </dl>
          <a className="app-download-btn" href={APP_RELEASE.href} download={APP_RELEASE.fileName}>
            {t('appDownload.download')}
          </a>
          <p className="app-download-note">{t('appDownload.note')}</p>
          <a className="app-download-checksum" href={APP_RELEASE.checksumHref}>
            {t('appDownload.checksumFile')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppDownload;
